import { api as generatedApi } from "~/gql/generatedApi.generated";
import {
	GetGlAccountsDocument,
	GetGlAccountsQuery,
	GetGlAccountsQueryVariables
} from "~/gql/queries/glAccounts.generated";

const glAccountsPaginatedApi = generatedApi.injectEndpoints({
	endpoints: (build) => ({
		GetGlAccounts: build.query<GetGlAccountsQuery, GetGlAccountsQueryVariables | void>({
			forceRefetch({ currentArg, previousArg }) {
				return currentArg?.after !== previousArg?.after;
			},
			merge(currentCache, newData) {
				if (currentCache.mergeDevAccounts && newData.mergeDevAccounts) {
					const existingMap = new Map((currentCache.mergeDevAccounts.nodes || []).map((node) => [node.id, node]));
					for (const node of newData.mergeDevAccounts.nodes || []) {
						existingMap.set(node.id, node);
					}
					currentCache.mergeDevAccounts.nodes = [...existingMap.values()];
					currentCache.mergeDevAccounts.pageInfo = newData.mergeDevAccounts.pageInfo;
					currentCache.mergeDevAccounts.totalCount = newData.mergeDevAccounts.totalCount;
				}
			},
			query: (variables) => ({ document: GetGlAccountsDocument, variables }),
			// key per filter/sort/page-size so the Income and COGS pickers keep separate caches; only $after varies within a key
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				const argsWithoutCursor = { ...(queryArgs ?? {}), after: undefined };
				return `${endpointName}(${JSON.stringify(argsWithoutCursor)})`;
			}
		})
	}),
	// overrideExisting is required so the paginated config (merge, serializeQueryArgs, forceRefetch) takes effect over the codegen stub
	overrideExisting: true
});

export default glAccountsPaginatedApi;
